import React, { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import AssistenteFinanceiro from '../components/AssistenteFinanceiro';

export default function AssistentePage() {
  const { usuario } = useAuthStore();

  const chatId = usuario?.email || 'sessao_convidado';

  const [chatMessages, setChatMessages] = useState([
    {
      role: 'assistant',
      content: `Olá, ${usuario?.nome || 'CFO'}. Sou o seu Assistente Financeiro. Como posso ajudar com suas importações hoje?`,
    },
  ]);

  return (
    <div className="animate-in fade-in duration-300">
      <div className="max-w-4xl mx-auto">
        <AssistenteFinanceiro
          chatId={chatId}
          mensagens={chatMessages}
          setMensagens={setChatMessages}
        />
      </div>
    </div>
  );
}
